import { FontCategory } from '@quicktools/shared-components/data/fonts';

const props = {
  canonicalPath: 'text/font-generator/bold/',
  headTitle: 'Bold Text Generator - Free Bold Fonts (𝑪𝒐𝒑𝒚 & 𝑷𝒂𝒔𝒕𝒆)',
  headDescription:
    'Say it loud & clear with our 𝐛𝐨𝐥𝐝 𝐭𝐞𝐱𝐭 𝐠𝐞𝐧𝐞𝐫𝐚𝐭𝐨𝐫. Choose from a variety of styles & use them for 𝐬𝐨𝐜𝐢𝐚𝐥 𝐦𝐞𝐝𝐢𝐚, 𝐩𝐫𝐢𝐧𝐭 𝐦𝐚𝐭𝐞𝐫𝐢𝐚𝐥𝐬, 𝐰𝐞𝐛𝐬𝐢𝐭𝐞𝐬, or elsewhere.',
  description:
    'Convert your text to bold for free with the #1 (Bold) Text Generator. Quickly highlight the important words and sentences in your text.',
  heading: (
    <>
      <strong>Bold Text Generator</strong> - Free Bold Fonts (Copy & Paste)
    </>
  ),
  selectedCategory: FontCategory.Bold,
  inputPlaceholder: 'Make here your text bold…',
};

export default props;
